<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-home"></i> 资讯管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
		<div class="handle-box">
			<router-link to="consultsadd">
				<el-button
			    type="primary"
			    icon="el-icon-circle-plus-outline"
			    class="handle-add"
			>添加</el-button></router-link>
		</div>
        <div class="container">
            <el-table
                :data="consultsData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
            >
                <el-table-column prop="title" label="标题"></el-table-column>
                <el-table-column prop="author" label="作者"></el-table-column>
				<el-table-column prop="publishDateStr" label="发布日期"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
						<router-link :to="'/consultsee/'+scope.row.consultId" >
							<el-button 
							    type="text"
							    icon="el-icon-view"
							>查看</el-button>
						</router-link>
						<router-link :to="'/consultsedit/'+scope.row.consultId" >
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                        >编辑</el-button>
						</router-link>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            @click="consultDelete(scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
		
    </div>
</template>




<script>
import {listConsults , deleteConsult} from '@/api/index';// 导入我们的api接口

export default {
    name: 'consults',
    data() {
        return {
            query: {
                pageIndex: 1,
                pageSize: 10
            },   //分页
			pageTotal: 0,  //数据总条数
            consultsData: [],  //列表数据
			
        };
    },
    created() {
		var that = this;
		// 列表数据
		this.getlistConsults();
    },
    methods: {
		// 获取列表数据
		getlistConsults(){
			listConsults({
				current: this.query.pageIndex,                    
				size: this.query.pageSize              
			}).then(res => {
				// 获取数据成功后的其他操作
				this.consultsData = res.data.records;  
			    this.pageTotal = res.data.total;
			});
		},
		
		
	   // 查看操作
	   // consultsee(row){
		  // this.seeVisible = true; 
		  // getBranchOrganization({
			 // "accountId": row.accountId,
			 // "organizationId": row.organizationId,
			 // "personId": row.personId              
		  // }).then(res => {
			 //  // 获取数据成功后的其他操作
			 //  this.seebrachlist = res.data;        
		  // });
	   // },
        // 删除操作
        consultDelete(row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
				deleteConsult({},{
					 "consultId": row.consultId,
				}).then(res => {
					this.query.pageIndex = 1;
					this.getlistConsults();
					if(res.code == 0){
					  // 获取数据成功后的其他操作
						this.$message({
						  message: res.message,
						  type: 'success'
						});
					}else if(res.code == 1){
						  this.$message({
							message: res.message,
							type: 'warning'
						  });
					}else{
						  this.$message({
							message: '报错啦!',
							type: 'warning'
						  });
					}
					
				});
			}).catch(() => {});
        },
       
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getlistConsults();
        }
    }
};
</script>

<style scoped>
.handle-box {
	height: 32px;
	line-height: 32px;
    margin-bottom: 10px;
}
.handle-add{
	float: right;
}
.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

/* 弹框样式 */
.branch-dialog-title{
	border-left: 4px solid #409EFF;
	font-size: 16px;
	text-indent: 10px;
	margin-bottom: 20px;
}

.see-list p{
	/* line-height: 32px; */
	margin-bottom: 20px;
	letter-spacing: 1px;
	font-size: 14px;
	text-indent: 15px;
}



</style>
<style>
.branch-dialog	.el-dialog__header{
	background:#409EFF;
	padding: 10px 20px;
}
.branch-dialog	.el-dialog__header	.el-dialog__title{
	color: #fff;
}
.branch-dialog	.el-dialog__header .el-dialog__headerbtn{
	background:#409EFF;
	top: 12px;
}
.branch-dialog	.el-dialog__header .el-dialog__headerbtn .el-dialog__close{
	color: #fff;
	font-size: 20px;
}
.branch-dialog .el-dialog__body{
	height:50vh;
	overflow-y: scroll;
	padding: 20px 20px 30px;
}
.branch-dialog .el-form-item__label{
	/* text-align: left; */
	width: 130px;
}
.branch-dialog .el-form-item__content{
	margin-left: 130px;
}

.branch-area{
	position: relative;
	height:32px;
	line-height: 32px;
	margin-bottom: 4px;
}
.branch-area span{
	display: block;
	width:118px;
	text-align: right;
}
.branch-area span::before{
	content: '*';
	color: #F56C6C;
	margin-right: 4px;
}
.branch-area i{
	position: absolute;
	top: 7px;
	right: 0;
	font-size: 20px;
	cursor: pointer;
}
.branch-areaitem{
	position: relative;
}
.branch-areaitem .el-cascader{
	width: 90%;
}
.branch-areaitem b{
	position: absolute;
	top: 7px;
	right: 0;
	font-size: 20px;
	cursor: pointer;
}
.branch-password .el-form-item__label::before{
	content: '*';
	color: #F56C6C;
	margin-right: 4px;
}
</style>
